<template>
  <dialog ref="dialogEl" @close="handleDialogClose" class="rounded-lg shadow-xl p-0 max-h-[90vh] max-w-4xl w-full sm:my-8 border-0 mx-auto">
    <div class="relative bg-white p-6 overflow-y-auto max-h-[calc(90vh-3rem)]"> <!-- Inner padding and scroll handling -->
      <slot></slot>
    </div>
  </dialog>
</template>

<script setup>
import { ref, watchEffect, onMounted } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const dialogEl = ref(null)

watchEffect(() => {
  if (dialogEl.value) {
    if (props.modelValue) {
      if (!dialogEl.value.open) {
        dialogEl.value.showModal()
      }
    } else {
      if (dialogEl.value.open) {
        dialogEl.value.close()
      }
    }
  }
})

const handleDialogClose = () => {
  if (props.modelValue) {
    emit('update:modelValue', false)
  }
}

</script>

<style scoped>
  dialog::backdrop {
    background-color: rgba(107, 114, 128, 0.75);
  }
</style>
